import { useMediaQuery, useTheme } from "@mui/material";
import { useOrderFlow } from "../../../OrderFlow/OrderFlowProvider/OrderFlowContext";
import { useCompany } from "../../../Shared/components/CompanyProvider/CompanyProvider";
import { CurrentBreakpoint, } from "./ToggleableOrdersList-types";
import { filterConditionalElementsLists, getDateFormat, getCurrentBreakpoint } from "./ToggleableOrdersList-utils";
/**
 *
 * @param isSubscriptionSummaryPage
 * @param orders
 * @returns
 */
export const useToggleableOrdersList = (isSubscriptionSummaryPage, orders) => {
    const { culture } = useCompany();
    const { store } = useOrderFlow();
    const theme = useTheme();
    const isXS = useMediaQuery(theme.breakpoints.up("xs"), { noSsr: true }); // 320px - 600px
    const isSmall = useMediaQuery(theme.breakpoints.up("sm"), { noSsr: true }); // 600px - 960px
    const isMedium = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true }); // 960px - 1280px
    const isLarge = useMediaQuery(theme.breakpoints.up("lg"), { noSsr: true }); // 1280px and up
    const currentBreakpoint = getCurrentBreakpoint(isXS, isSmall, isMedium, isLarge);
    const selectedMealsChipText = store.model.SelectedMealsChipText;
    const dateFormat = getDateFormat(currentBreakpoint);
    const gridTemplateColumns_Breakpoints = isSubscriptionSummaryPage
        ? {
            //10% 20% 15% 15% 30% 10%
            xx: "20% 80%",
            xs: "20% 80%",
            sm: "10% 35% 35% 20%",
            md: "10% 25% 25% 20% 20%",
            lg: "10% 20% 15% 15% 30% 10%", // 1280px and up
        }
        : {
            xx: "20% 80%",
            xs: "20% 80%",
            sm: "10% 40% 20% 30%",
            md: "10% 30% 20% 20% 20%",
            lg: "10% 30% 20% 20% 20%", // 1280px and up
        };
    const gridTemplateAreas_Breakpoints = isSubscriptionSummaryPage
        ? {
            // At small breakpoints, display the date and title on a single line with the meals selected chip below it.
            xx: `"checkbox week" 
            ". chip"
            `,
            xs: `"checkbox week"
            ". chip"
            `,
            sm: `"checkbox week chip total"`,
            md: `"checkbox week chip total fulfillment"`,
            lg: `"checkbox week chip total fulfillment orderNumber"`, // 1280px and up
        }
        : {
            xx: `"checkbox week"`,
            xs: `"checkbox week"`,
            sm: `"checkbox week total fulfillment"`,
            md: `"checkbox week total fulfillment orderNumber"`,
            lg: `"checkbox week total fulfillment orderNumber"`, // 1280px and up
        };
    const gridTemplateColumns = gridTemplateColumns_Breakpoints[currentBreakpoint];
    const gridTemplateAreas = gridTemplateAreas_Breakpoints[currentBreakpoint];
    const filteredElements = filterConditionalElementsLists(gridTemplateAreas, orders);
    const isXXOrXS = currentBreakpoint === CurrentBreakpoint.XX || currentBreakpoint === CurrentBreakpoint.XS;
    const titleTypographyVariant = isXXOrXS ? "body1" : "h7";
    return {
        culture,
        theme,
        dateFormat,
        gridTemplateColumns,
        gridTemplateAreas,
        selectedMealsChipText,
        currentBreakpoint,
        filteredElements,
        titleTypographyVariant,
        isXXOrXS,
    };
};
